


















import { Component, Vue, Prop } from "vue-property-decorator";
import { mapMutations } from "vuex";
import IPanel from "../../models/panel-model";

@Component({
  methods: {
    ...mapMutations(["openDetailPanel"]),
  }
})
export default class PanelComponent extends Vue {
  @Prop() panel!: IPanel;
}
